import routes from '../../../constants/routes';

const getFooterLinks = (navigate: (path: string) => void) => [
  {
    label: 'Terms of Service',
    onClick: () => navigate(routes.TERMS_AND_CONDITIONS)
  },
  {
    label: 'Privacy Policy',
    onClick: () => navigate(routes.PRIVACY_POLICY)
  }
];

export { getFooterLinks };
